import getFormValues from './getFormValues';

// ----------------------------------------------------------------------------

function normalizeScalar(value: unknown): string {
    return value == null ? '' : JSON.stringify(value);
}

function normalizeValue(value: unknown): string | string[] {
    if (Array.isArray(value)) {
        return value.map((item): any => normalizeScalar(item)).sort();
    }

    return normalizeScalar(value);
}

function hasFormChanged(form: HTMLFormElement, originalData: Record<string, unknown>): boolean {
    const currentData = getFormValues(form);
    const keys = new Set([...Object.keys(originalData), ...Object.keys(currentData)]);

    for (const key of keys) {
        const currentValue = normalizeValue(currentData[key]);
        const originalValue = normalizeValue(originalData[key]);

        if (Array.isArray(originalValue) && Array.isArray(currentValue)) {
            if (originalValue.length !== currentValue.length) {
                return true;
            }

            if (!originalValue.every((val): any => currentValue.includes(val))) {
                return true;
            }
        } else if (originalValue !== currentValue) {
            return true;
        }
    }

    return false;
}

// ----------------------------------------------------------------------------

export default hasFormChanged;
